import {BaseDTO} from "./_baseDTO.interface";
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface FuelTypeDTO extends BaseIntDTO {
  fuelTypeName: string;
}
